module.exports = __webpack_public_path__ + "static/media/food3.84964c7a.png";